const PIXEL_ID = "549021146363696";
if (window.location.pathname === "/pages/shop-shower-doors") {
  // 1. Facebook Pixel Initialization
  (function initializeFacebookPixel() {
    if (typeof fbq === "undefined") {
      !(function (f, b, e, v, n, t, s) {
        if (f.fbq) return;
        n = f.fbq = function () {
          n.callMethod
            ? n.callMethod.apply(n, arguments)
            : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = !0;
        n.version = "2.0";
        n.queue = [];
        t = b.createElement(e);
        t.async = !0;
        t.src = v;
        s = b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t, s);
      })(
        window,
        document,
        "script",
        "https://connect.facebook.net/en_US/fbevents.js",
      );

      fbq("init", PIXEL_ID);
      fbq("trackSingle", PIXEL_ID, "PageView");
    }
  })();

  // 2. Enhanced Tracking Configuration
  const retailerTrackingConfig = {
    // PriceSpider tracking
    defaultEvent: "RetailerClicks",
    retailers: {
      "Home Depot": "THDClicks",
      "Lowe's": "LowesClicks",
      Amazon: "AmazonClicks",
    },

    // Banner buttons tracking
    bannerButtons: {
      'a[href*="thd.co"]': "THDClicks",
      'a[href*="low.es"]': "LowesClicks",
      'a[href*="amzn.to"]': "AmazonClicks",
    },

    // Special buttons tracking
    specialButtons: {
      'a[href="/pages/shower-door-finder"]': "InitiateCheckout",
      // Add more special buttons here as needed
    },

    getTrackingEvent: function (retailerName) {
      const matchedRetailer = Object.keys(this.retailers).find((key) =>
        retailerName.includes(key),
      );
      return matchedRetailer ? this.retailers[matchedRetailer] : null;
    },
  };

  // 3. Main Tracking Function
  function trackRetailerClicks() {
    // PriceSpider Tracking
    const priceSpiderObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) {
            const buttons =
              node.querySelectorAll?.(".ps-online-buy-button") || [];
            if (node.classList?.contains("ps-online-buy-button")) {
              buttons.push(node);
            }
            buttons.forEach((button) => {
              button.addEventListener("click", (event) => {
                event.stopPropagation();
                handlePriceSpiderClick(event.target);
              });
            });
          }
        });
      });
    });

    priceSpiderObserver.observe(document.body, {
      childList: true,
      subtree: true,
    });
    document.querySelectorAll(".ps-online-buy-button").forEach((button) => {
      button.addEventListener("click", (event) => {
        event.stopPropagation();
        handlePriceSpiderClick(event.target);
      });
    });

    // Banner Button Tracking
    function trackBannerButtons() {
      Object.entries(retailerTrackingConfig.bannerButtons).forEach(
        ([selector, eventName]) => {
          document.querySelectorAll(selector).forEach((button) => {
            button.addEventListener("click", () => {
              if (typeof fbq !== "undefined") {
                fbq("trackSingle", PIXEL_ID, eventName);
                fbq(
                  "trackSingle",
                  PIXEL_ID,
                  retailerTrackingConfig.defaultEvent,
                );
              }
            });
          });
        },
      );
    }

    const bannerObserver = new MutationObserver(trackBannerButtons);
    bannerObserver.observe(document.body, { childList: true, subtree: true });
    trackBannerButtons();

    // Special Button Tracking (including Find Now button)
    function trackSpecialButtons() {
      Object.entries(retailerTrackingConfig.specialButtons).forEach(
        ([selector, eventName]) => {
          document.querySelectorAll(selector).forEach((button) => {
            button.addEventListener("click", () => {
              if (typeof fbq !== "undefined") {
                fbq("trackSingle", PIXEL_ID, eventName);
              }
            });
          });
        },
      );
    }

    const specialButtonObserver = new MutationObserver(trackSpecialButtons);
    specialButtonObserver.observe(document.body, {
      childList: true,
      subtree: true,
    });
    trackSpecialButtons();

    // Event Handlers
    function handlePriceSpiderClick(clickedElement) {
      const button = clickedElement.closest(".ps-online-buy-button");
      if (!button) return;

      const retailerWrapper = button.closest("[data-retailer]");
      if (retailerWrapper) {
        const retailerName = retailerWrapper
          .getAttribute("data-retailer")
          .trim();

        if (typeof fbq !== "undefined") {
          fbq("trackSingle", PIXEL_ID, retailerTrackingConfig.defaultEvent);
          const specificEvent =
            retailerTrackingConfig.getTrackingEvent(retailerName);
          if (specificEvent) fbq("trackSingle", PIXEL_ID, specificEvent);
        }
      }
    }

    // Cleanup function
    return () => {
      priceSpiderObserver.disconnect();
      bannerObserver.disconnect();
      specialButtonObserver.disconnect();
    };
  }

  // Initialize tracking
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", trackRetailerClicks);
  } else {
    trackRetailerClicks();
  }
}
